import { render } from "./LoadingIndicator.vue?vue&type=template&id=65fb9f48&scoped=true"
import script from "./LoadingIndicator.vue?vue&type=script&lang=js"
export * from "./LoadingIndicator.vue?vue&type=script&lang=js"

import "./LoadingIndicator.vue?vue&type=style&index=0&id=65fb9f48&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-65fb9f48"]])

export default __exports__